module.exports = __webpack_public_path__ + "static/media/ubc_logo.0bb5a264.png";